import "./App.css";
import Navbar from "./components/nav/Navbar";

import { Outlet, createBrowserRouter, RouterProvider } from "react-router-dom";

import HomePage from "./components/home/Home";
import CreatePage from "./components/create/Create";
import SinglePage from "./components/single/Single";
import Loginn from "./components/login/Login";
import Footer from "./components/footer/Footer";
import Contact from "./components/footer/Contact";
import TopStories from "./components/home/TopStories";
import Team from "./components/footer/Team";
import AllTop from "./components/home/AllTop";

const Layout = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Navbar />
      <Outlet />
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/top", element: <TopStories /> },
      { path: "/top-stories", element: <AllTop /> },
      { path: "/contact", element: <Contact /> },
      { path: "/write", element: <CreatePage /> },
      { path: "/post/:id", element: <SinglePage /> },
      { path: "/about", element: <Footer /> },
      { path: "/team", element: <Team /> },
    ],
  },
  { path: "login", element: <Loginn /> },
]);
function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
